import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mediaType',
    standalone: false
})
export class MediaTypePipe implements PipeTransform {

  static findType(filename: any): string {
    if (!filename) {
      return 'directory';
    }

    const image = () => 'image';
    const video = () => 'video';
    const audio = () => 'audio';
    const defaultType = 'file';

    const map: Record<string, string> = {
      jpg: image(),
      jpeg: image(),
      png: image(),
      gif: image(),
      webp: image(),
      mp4: video(),
      m4a: video(),
      mov: video(),
      mpeg: video(),
      avi: video(),
      mkv: video(),
      webm: video(),
      ogg: video(),
      ogv: video(),
      mp3: audio(),
      wav: audio(),
      flac: audio(),
      aac: audio(),
      wma: audio(),
    };

    return map[filename.toLowerCase().split('.').pop()] ?? defaultType;
  }

  transform(media: any): string {
    return MediaTypePipe.findType(media);
  }
}
